import React from "react";
import classes from "./AccountMenu.module.scss";
import {
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
} from "mdbreact";

type AccountMenuProps = {
  /** メニュー一覧 */
  menuList: MenuElement[];
};

export type MenuElement = {
  /** メニュー表示テキスト */
  text: string;
  /** クリック時の動作 */
  onClick: () => void;
};

const AccountMenu: React.FC<AccountMenuProps> = (props) => {
  return (
    <MDBDropdown dropup className={classes.menuContainer}>
      <MDBDropdownToggle
        color=""
        className={`${classes.menuButton} d-flex align-items-center justify-content-center`}
      >
        <MDBIcon icon="bars" />
      </MDBDropdownToggle>
      <MDBDropdownMenu className={classes.menuList}>
        {props.menuList.map((ml, i) => {
          return (
            <MDBDropdownItem
              key={i}
              onClick={ml.onClick}
              className={classes.menuItem}
            >
              <div className="my-1">{ml.text}</div>
            </MDBDropdownItem>
          );
        })}
      </MDBDropdownMenu>
    </MDBDropdown>
  );
};

export default AccountMenu;
